import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { research } from "../../../TextData";
// import "../../research-group.scss";
export const MainResearch = () => {
  const [data, setData] = useState({});
  const [id, setId] = useState(0);
  const location = useLocation();
  useEffect(() => {
    setId(location.state.blog_id);
    console.log(id, location.state);
  }, []);

  useEffect(() => {
    if (id != 0)
      setData(
        research.find((obj) => {
          return obj.id == id;
        })
      );
    // console.log(data, research, id);
  }, [id]);
  return (
    <>
      <div className="col-md-12 research-container">
        <Link to={"/research-groups"} className="offset-md-1 blog-link2">
          <i class="icofont-arrow-left"></i>Back
        </Link>
      </div>{" "}
      {data ? (
        <>
          <div
            className="col-md-6 main-img offset-md-3"
            style={{ backgroundImage: `url(${data.img})` }}
          ></div>

          <div className="col-md-6 offset-md-3 mt3">
            <h2>{data.researchTitle}</h2>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};
